/**
 * Normalisation dédiée à la recherche produit (Admin / POS).
 * Ne pas confondre avec normalizeForMatch (caractéristiques / slugs) :
 * ce helper ajoute la tolérance apostrophes / tirets / forme compacte.
 *
 * Miroir comportemental : website/lib/utils/normalizeSearchText.js
 */

const SEPARATORS_RE = /['\u2018\u2019\u0060\u00B4\-\u2013\u2014]/g;

function foldForSearch(input) {
  if (input == null) return '';
  if (typeof input !== 'string') {
    if (typeof input === 'number' || typeof input === 'boolean') {
      input = String(input);
    } else {
      return '';
    }
  }
  return input
    .trim()
    .toLowerCase()
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * @param {unknown} input
 * @returns {{ normal: string, compact: string }}
 */
export function normalizeSearchText(input) {
  const normal = foldForSearch(input)
    .replace(SEPARATORS_RE, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return {
    normal,
    compact: normal.replace(/\s+/g, ''),
  };
}

/**
 * La requête vide matche tout. Sinon : sous-chaîne sur forme NORMAL ou COMPACT.
 * @param {unknown} haystack
 * @param {unknown} query
 * @returns {boolean}
 */
export function matchSearchText(haystack, query) {
  const q = normalizeSearchText(query);
  if (!q.normal) return true;
  const h = normalizeSearchText(haystack);
  if (h.normal.includes(q.normal)) return true;
  if (q.compact && h.compact.includes(q.compact)) return true;
  return false;
}
